import React, { useEffect, useState } from "react";
import { Container, Typography, Paper } from "@mui/material";
import { SessionManager } from "../utils/consts";

export interface ProfileDataProps {
  email: string;
  id: number;
  name: string;
  phone_number: string;
  address: string;
  location: string;
}

interface ProfileProps {
  sessionManager: SessionManager;
}

const Profile: React.FC<ProfileProps> = ({ sessionManager }) => {
  const [profile, setProfile] = useState<ProfileDataProps | null>(null);
  const getProfile = async () => {
    const responseData = await sessionManager.getData("profile");
    setProfile(responseData);
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    // if profile
    <Container maxWidth="sm" style={{ marginTop: "20px" }}>
      <Paper elevation={3} style={{ padding: "20px" }}>
        <Typography variant="h4" gutterBottom>
          Profile
        </Typography>
        <div>
          <Typography variant="body1">Email: {profile?.email}</Typography>
          <Typography variant="body1">ID: {profile?.id}</Typography>
          <Typography variant="body1">Name: {profile?.name}</Typography>
          <Typography variant="body1">
            Phone Number: {profile?.phone_number}
          </Typography>
          <Typography variant="body1">Address: {profile?.address}</Typography>
          <Typography variant="body1">Location: {profile?.location}</Typography>
        </div>
      </Paper>
    </Container>
  );
};

export default Profile;
